export default "__VITE_ASSET__8ae82184__"